import { RefObject } from "react";

import { PINNED_COLUMN_MIN_TABLE_WIDTH } from "ds/components/Table/constants";
import useTableWidth from "ds/components/Table/hooks/useTableWidth";

import { fitsPinnedColumn } from "../helpers";

type UseTableSimpleEffectiveColumnPinningResult = {
  effectiveIsFirstColumnPinned: boolean;
  isPinningEnabled: boolean;
};

const useTableSimpleEffectiveColumnPinning = (
  tableRef: RefObject<HTMLDivElement | null> | undefined,
  isFirstColumnPinned: boolean,
  // For a table whose first column sizes itself from its content, such as a tree indenting by
  // depth: once it needs most of the table, pinning it would leave nothing to scroll behind it.
  firstColumnMinWidth?: number
): UseTableSimpleEffectiveColumnPinningResult => {
  const tableWidth = useTableWidth(tableRef, true);
  const isPinningEnabled =
    typeof tableWidth === "undefined" ||
    (tableWidth >= PINNED_COLUMN_MIN_TABLE_WIDTH &&
      fitsPinnedColumn(tableWidth, firstColumnMinWidth));

  return {
    effectiveIsFirstColumnPinned: isFirstColumnPinned && isPinningEnabled,
    isPinningEnabled,
  };
};

export default useTableSimpleEffectiveColumnPinning;
